module.exports = __webpack_public_path__ + "static/img/wuxinxi_img.8325bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wuxinxi_img.png
// module id = 4X44
// module chunks = 1